import { render, staticRenderFns } from "./osMarker.vue?vue&type=template&id=354b2136&"
import script from "./osMarker.vue?vue&type=script&lang=js&"
export * from "./osMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports